<template>
  <div class="page page-contact">
    <section class="section">
      <div class="section-inner">
        <div class="section-header">
          <h2 class="section-title">联系方式</h2>
          <p class="section-subtitle">期待与您建立长期、稳定、互信的合作关系。</p>
        </div>
        <div class="contact-body">
          <div class="contact-row">
            <div class="label">商务合作电话</div>
            <div class="value">13913874888 （工作日 9:00-18:00）</div>
          </div>
          <div class="contact-row">
            <div class="label">商务合作邮箱</div>
            <div class="value">40079765@qq.com</div>
          </div>
          <div class="contact-row">
            <div class="label">售后支持邮箱</div>
            <div class="value">lvdunning007@163.com</div>
          </div>
          <div class="contact-row">
            <div class="label">公司地址</div>
            <div class="value">江苏省南京市鼓楼区中山北路105-号 中环-锦创数字广场808</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactPage'
}
</script>

<style scoped>
.page {
  background: #f5f7fa;
}

.contact-body {
  background: #ffffff;
  border-radius: 18px;
  padding: 20px 22px;
  box-shadow: 0 16px 40px rgba(15, 23, 42, 0.1);
}

.contact-row {
  display: flex;
  padding: 10px 0;
  font-size: 14px;
}

.contact-row + .contact-row {
  border-top: 1px solid #e5e9f0;
}

.label {
  width: 120px;
  color: #7b8794;
}

.value {
  flex: 1;
  color: #102a43;
}

@media (max-width: 640px) {
  .contact-row {
    flex-direction: column;
  }

  .label {
    margin-bottom: 2px;
  }
}
</style>

